// material-ui
import { InputLabel } from '@mui/material'
import React from 'react'

import { Divider, Grid } from '@mui/material'
import rq from 'components/RedQuick'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'

import { gridSpacing } from 'store/constant'

import { SystemSettingTypes } from 'features/enumerations'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import { getUserClaims } from 'features/application/application-slice'
import { get_all_releaseZone } from 'features/releaseZone/releaseZone-slice'
import { get_all_systemSetting } from 'features/systemSetting/systemSetting-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let systemSetting_list = useSelector(get_all_systemSetting)
  let releaseZone_list = useSelector(get_all_releaseZone)
  const [currentReleaseZone, setCurrentReleaseZone] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_system_settings({ ok: false }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && currentReleaseZone) {
      dispatch(
        autoThunks.set_current_release_zone_system_settings({
          releaseZoneId: (() => {
            function _getCurrentReleaseZone(): any {
              return currentReleaseZone
            }
            return _getCurrentReleaseZone()
          })(),
        }),
      )
    }
  }, [claims?.player, currentReleaseZone])
  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_release_zone_for_system_settings({ ok: false }))
    }
  }, [claims?.player])

  function getSelectedReleaseZone(): any {
    let settings = (systemSetting_list || []).find((v) => {
      return v.name === SystemSettingTypes.ReleaseZone
    })

    return currentReleaseZone || settings?.value
  }

  function getSelectedReleaseZoneTitle(): any {
    let val = getSelectedReleaseZone()
    let settings = (releaseZone_list || []).find((v) => {
      return v.id === currentReleaseZone || val
    })

    return settings?.name || TitleService('Unknown')
  }

  function releaseZoneItemForm(): any {
    return (
      <>
        <Grid item xs={12} sm={12} md={12}>
          <Grid item xs={12} lg={6}>
            <InputLabel>{TitleService('Default Release Zone')}</InputLabel>
            <rq.RedQuickDropdown
              value={getSelectedReleaseZone()}
              title={getSelectedReleaseZoneTitle()}
              options={(releaseZone_list || []).map((list: any) => {
                return {
                  label: TitleService(list.name || list.description),
                  value: list.id,
                }
              })}
              onChange={async (val) => {
                setCurrentReleaseZone(val)
              }}
            />
          </Grid>
        </Grid>
        <Divider />
      </>
    )
  }

  let output_releaseZoneItemForm = releaseZoneItemForm()

  function main_card(modelForm: any): any {
    return (
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12}>
          <MainCard title={TitleService('System Settings')}>
            {modelForm}
          </MainCard>
        </Grid>
      </Grid>
    )
  }

  let output_main_card = main_card(output_releaseZoneItemForm)

  return output_main_card
}
